export const GET_SCHEDULED_LIST = "GET_SCHEDULED_LIST"
export const GET_SCHEDULED_LIST_SUCCESS = "GET_SCHEDULED_LIST_SUCCESS"
export const GET_SCHEDULED_LIST_FAIL = "GET_SCHEDULED_LIST_FAIL"
export const GET_SCHEDULED_DETAIL = "GET_SCHEDULED_DETAIL"
export const GET_SCHEDULED_DETAIL_SUCCESS = "GET_SCHEDULED_DETAIL_SUCCESS"
export const GET_SCHEDULED_DETAIL_FAIL = "GET_SCHEDULED_DETAIL_FAIL"
export const CANCEL_SCHEDULED = "CANCEL_SCHEDULED"
export const CANCEL_SCHEDULED_SUCCESS = "CANCEL_SCHEDULED_SUCCESS"
export const CANCEL_SCHEDULED_FAIL = "CANCEL_SCHEDULED_FAIL"
export const FREEZE_SCHEDULED = "FREEZE_SCHEDULED"
export const FREEZE_SCHEDULED_SUCCESS = "FREEZE_SCHEDULED_SUCCESS"
export const FREEZE_SCHEDULED_FAIL = "FREEZE_SCHEDULED_FAIL"
export const RESET_SCHEDULED_FLAG = "RESET_SCHEDULED_FLAG"
